<template>
  <artmisads-select
    show-search
    :value="modelValue"
    :style="{ width }"
    :options="options"
    :show-arrow="showArrow"
    :filter-option="false"
    :not-found-content="notFoundContent"
    :placeholder="placeholder"
    :allowClear="allowClear"
    :getPopupContainer="getPopupContainer"
    :disabled="disabled"
    @search="onSearch"
    @change="onChange"
  />
</template>

<script setup>
import { ref, watch } from 'vue'
import { COUNTRY_BASE } from '~/contants/common'
import { reportsApi, publisherReportsApi, publisherAdminApi } from '~/server/index'

const props = defineProps({
  modelValue: {
    type: [String, Number],
    default: undefined,
  },
  /** publisher | seller | operator */
  platform: {
    type: String,
    default: 'operator',
  },
  marketplace: {
    type: String,
    default: 'amazon.com',
  },
  placeholder: {
    type: String,
    default: 'All',
  },
  width: {
    type: String,
    default: '232px',
  },
  allowClear: {
    type: Boolean,
    default: true,
  },
  showArrow: {
    type: Boolean,
    default: false,
  },
  notFoundContent: {
    type: [String, Object],
    default: null,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  getPopupContainer: {
    type: Function,
    default: undefined,
  },
})

const emit = defineEmits(['update:modelValue', 'change', 'search'])

const options = ref([])

const mapBrandOptions = (list = []) =>
  list.map((item) => {
    const hasDuplicate = list.some(
      (otherItem) =>
        otherItem.amazonBrandName === item.amazonBrandName &&
        otherItem.id !== item.id,
    )
    return {
      ...item,
      label: hasDuplicate
        ? `${item.amazonBrandName} (${item.amazonProfileAccountInfoName})`
        : item.amazonBrandName,
      value: item.id,
    }
  })

const onSearch = async (keyword) => {
  emit('search', keyword)
  let res
  if (props.platform === 'publisher') {
    const countryCode = COUNTRY_BASE.find(
      (i) => i.host === props.marketplace,
    )?.countryCode
    res = await publisherReportsApi.getPublisherBrandSearch({
      keywords: keyword,
      countryCode,
    })
  } else if (props.platform === 'seller') {
    res = await reportsApi.getSellerBrandSearch({
      keyword,
      marketplace: props.marketplace,
    })
  } else {
    res = await publisherAdminApi.searchBrand({
      keyword,
      marketplace: props.marketplace,
    })
  }

  if (props.platform === 'operator') {
    options.value = mapBrandOptions(res || [])
    return
  }

  const { success, data } = res || {}
  options.value = success ? mapBrandOptions(data || []) : []
}

const onChange = (value, option) => {
  emit('update:modelValue', value)
  emit('change', value, option)
}

watch(
  () => [props.marketplace, props.platform],
  () => {
    options.value = []
  },
)
</script>
